<template>
  <div class="navigation">
    <slot></slot>
  </div>
</template>

<script lang="js">
import { mapState } from "vuex";

export default {
  name: "ahc-navigation",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(["drawerOpen"]),
    breakpointName() {
      return this.$breakpoint.name;
    },
  },
  watch: {
    // whenever the nav drawer opens
    drawerOpen(isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          this.setLinkHeights();
        });
      }
    },
    breakpointName() {
      this.setLinkHeights();
    },
  },
  methods: {
    /**
     * The secondary links of each *row* of nav items
     * need to be top-aligned with each other. This gathers
     * the top-level items of each row, and sets min-heights accordingly
     */
    setLinkHeights() {
      // gather all top-level nav links
      const allLinks = [].slice.call(
        this.$el.querySelectorAll(".nav__primary:not(.nav__primary--has-text)")
      ); // converts nodelist to array
      // split into two rows
      const rows = [allLinks.slice(0, 5), allLinks.slice(5, 10)];

      if (this.breakpointName === "xl") {
        rows.forEach((row) => {
          let height = 0;
          // loop over to determine the tallest one
          row.forEach((item) => {
            if (item.offsetHeight > height) {
              height = item.offsetHeight;
            }
          });
          // set them all with the same min-height
          row.forEach((item) => {
            item.style.minHeight = height + "px";
          });
        });
      } else {
        rows.forEach((row) => {
          row.forEach((item) => {
            item.style.minHeight = "";
          });
        });
      }
    },
  },
};
</script>

<style lang="scss">
// only import scss files here if this is a lazy-loaded component.
// otherwise, component scss imports go in components.scss
</style>
